import { ELianlianCardStatus } from '../../lianlian';
import { EPaymentChannel, IAccountApplySubmit } from '../../common';

export interface IPayeeItem {
  id: string;
  /** 连连卡包状态 */
  accountStatus?: ELianlianCardStatus;
  /** 通道id */
  channelType?: EPaymentChannel;
  /** 连连id */
  lianId?: number;
  /** yopId id */
  yopId?: number;
  /** 收款方名称 */
  name: string;
  /** 收款方编号 */
  payeeNo: string;
  /** 收款方类型 */
  payeeType: EPayeeUserType;
  /** 收款状态 */
  status: EPayeeUserStatus;
  /** 创建时间 */
  createTime: string;
  /** 失败原因 */
  failReason?: string;

  showManage?: boolean;
  showEditYibao?: boolean;
  /** 开户意愿认证？ */
  showVerify?: boolean;
  /** 开户意愿认证链接地址 */
  openAccountWillUrl?: string;
  /** 银行名称 */
  bankName?: string;
  /** 银行账户 */
  bankAccount?: string;
  /** 企业ID */
  companyId: number;
  /** 企业名称 */
  companyName: string;
  /** 更新人 */
  updater: string;
  /** 更新人所在公司 */
  updaterCompany: string;
  /** 更新时间 */
  updateTime: string;
}

export enum EPayeeUserType {
  /** 个人 */
  Personal = 1,
  /** 企业 */
  Company = 2,
  /** 通道商户 */
  Channel = 3,
}

export const iPayeeUserTypeLabel = {
  [EPayeeUserType.Personal]: '个人',
  [EPayeeUserType.Company]: '企业',
  [EPayeeUserType.Channel]: '通道商户',
};

export enum EPayeeUserStatus {
  /** 启用 */
  Enable = 'ENABLED',
  /** 停用 */
  Disable = 'DISABLED',
  /** 申请中 */
  Applying = 'CHECK',
  /** 申请失败 */
  Failed = 'FAIL',
  /** 待申请 */
  ToApplying = 'PENDING',
  /** 已注销 */
  Cancel = 'CANCELLED',
}

export const payeeUserStatusLabel = {
  [EPayeeUserStatus.Enable]: '已启用',
  [EPayeeUserStatus.Disable]: '已停用',
  [EPayeeUserStatus.Applying]: '申请中',
  [EPayeeUserStatus.Failed]: '申请失败',
  [EPayeeUserStatus.ToApplying]: '待申请',
  [EPayeeUserStatus.Cancel]: '已注销',
};

export const payeeUserStatusStyle = {
  [EPayeeUserStatus.Enable]: 'success',
  [EPayeeUserStatus.Disable]: 'info',
  [EPayeeUserStatus.Applying]: 'warning',
  [EPayeeUserStatus.Failed]: 'danger',
  [EPayeeUserStatus.ToApplying]: 'warning',
  [EPayeeUserStatus.Cancel]: 'info',
};

export const payeeUserStatusOpts = [
  {
    label: payeeUserStatusLabel[EPayeeUserStatus.Enable],
    value: EPayeeUserStatus.Enable,
  },
  {
    label: payeeUserStatusLabel[EPayeeUserStatus.Disable],
    value: EPayeeUserStatus.Disable,
  },
  {
    label: payeeUserStatusLabel[EPayeeUserStatus.Applying],
    value: EPayeeUserStatus.Applying,
  },
  {
    label: payeeUserStatusLabel[EPayeeUserStatus.Failed],
    value: EPayeeUserStatus.Failed,
  },
  {
    label: payeeUserStatusLabel[EPayeeUserStatus.ToApplying],
    value: EPayeeUserStatus.ToApplying,
  },
  {
    label: payeeUserStatusLabel[EPayeeUserStatus.Cancel],
    value: EPayeeUserStatus.Cancel,
  },
];

export interface IPayeeParam {
  /** 通道id */
  channelType?: EPaymentChannel;
  /** 收款用户 */
  name?: string;
  /** 用户ID */
  payeeNo?: string;
  /** 用户类型 */
  payeeType?: EPayeeUserType;
  /** 用户状态 */
  status?: EPayeeUserStatus;
  page: number;
  size: number;
  /** 企业ID */
  companyId?: number;
}

export interface IPayeeApplySubmit extends IAccountApplySubmit {}

export interface ICompanyPayeeExcelImportResult{
  /** 导入表格地址 */
  fileUrl: string;
  /** 总条数 */
  totalCount: number;
  /** 是否全部导入成功 */
  fullSuccess: boolean;
  /** 成功条数 */
  successCount: number;
  /** 失败条数 */
  failureCount: number;
  /** 失败文件下载地址 */
  failureFileUrl: string;
}